import { AccountAuthen } from 'components/common/AccountAuthen';
import { ButtonCustom } from 'components/common/ButtonCustom';
import { TextForm } from 'components/common/form-item/TextForm';
import { PaginationCustom } from 'components/common/pagination/Pagination';
import { TableV2 } from 'components/common/TableV2';
import AuthContext from 'context/AuthProvider';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import toast from 'react-hot-toast';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useMutation, useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { checkReqPayment } from 'services/payment';
import { ButtonGradient } from '../../../components/common/button/ButtonGradient';
import { PATH_PAGE, PER_PAGE_DEFAULT, QUERY_KEY } from '../../../constant';
import { getCategory } from '../../../services/category';
import { getIconCategory } from '../../../utils/getIconCategory';
import { Products } from '../index';
import { CategoryContext } from './CategoryContext';

export const ProductsCategory = () => {
  const { userLogin } = useContext(AuthContext);
  const navigate = useNavigate();

  const [dataTable, setDataTable] = useState<{
    items: Array<any>;
    numberPerPage: number;
    pageNumber: number;
  }>({
    items: [],
    numberPerPage: 0,
    pageNumber: 0,
  });
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [perPage, setPerPage] = useState<number>(PER_PAGE_DEFAULT);

  const [searchString, setSearchString] = useState<string>('');
  const [packTypeChoice, setPackTypeChoice] = useState<Array<number>>([]);
  const [numExpiredChoice, setNumExpiredChoice] = useState<Array<number>>([]);
  const [traSau, setTraSau] = useState<number>(0);
  const [traTruoc, setTraTruoc] = useState<number>(0);
  const [amount, setAmount] = useState<Array<number>>([0, 0]);

  const [isShowNotification, setIsShowNotification] = useState<boolean>(false);

  const { data: dataCheckReqPayment } = useQuery(QUERY_KEY.REQ_PAYMENT, () => checkReqPayment(), { enabled: false });
  // 1 = du dk
  // 161 =  tài khoản chưa xác thực
  // 162 =  số dư chưa đủ
  // 163 =  giới hạn 1 lần 1 ngày
  // 164 =  thiếu thông tin ngân hàng
  const statusReqPayment = useMemo(() => {
    return dataCheckReqPayment?.data?.data?.code;
  }, [dataCheckReqPayment]);

  const mutationSearchCategory = useMutation((param: any) => getCategory(param), {
    onSuccess: (response) => {
      if (response?.data) {
        setDataTable({
          items: response.data.data,
          numberPerPage: 0,
          pageNumber: 0,
        });
        return;
      }
    },
    onError: (error) => {
      setDataTable({ items: [], numberPerPage: 0, pageNumber: 0 });
    },
  });

  const onSearchCategory = (_param?: { perPage?: number; currentPage?: number }) => {
    const keySearch = {
      name: searchString,
      page: _param?.currentPage || 1,
      sizeOfPage: _param?.perPage || perPage,
    };
    mutationSearchCategory.mutate(keySearch);
  };

  useEffect(() => {
    mutationSearchCategory.mutate({
      page: 1,
      name: '',
      sizeOfPage: PER_PAGE_DEFAULT,
    });
  }, []);

  const renderRow = useCallback(
    (row: any, index: number) => {
      console.log('row', row);
      let clipboardLink = row.link;
      if (row.id === 1) {
        clipboardLink = process.env.REACT_APP_BASE_URL + '/product/sim-so-dep';
      } else if (row.id === 2) {
        clipboardLink = process.env.REACT_APP_BASE_URL + '/product/goi-cuoc-uu-dai';
      }

      let detailLink = row.link;
      if (row.id === 1) {
        detailLink = process.env.REACT_APP_BASE_URL + '/products/sim';
      } else if (row.id === 2) {
        detailLink = process.env.REACT_APP_BASE_URL + '/products/service-plan';
      }
      return (
        <tr
          key={row.id}
          className="cursor-fancy rounded-l-[15px] rounded-tr-[15px] bg-white shadow-base hover:z-50 hover:shadow-[0px_0px_10px_rgba(209,209,209,0.2)] hover:drop-shadow-[0px_0px_8px_rgba(255,158,110,0.6)]"
        >
          <th scope="row" className="rounded-l-[15px] px-2 py-2.5 text-center text-base font-medium text-[#404040]">
            {index + 1 + (currentPage - 1) * perPage}
          </th>
          <th scope="row" className="px-2 py-2.5 text-center text-base font-medium text-[#404040]">
            {row.name}
          </th>
          <th scope="row" className="w-[20%] px-2 py-2.5 text-center text-base font-medium text-[#404040]">
            {row.commission}
          </th>
          <th scope="row" className="rounded-tr-[15px] px-2 py-2.5 text-center font-normal text-gray-700">
            <div className={'flex flex-row items-center justify-center space-x-2.5'}>
              <ButtonGradient
                className={'h-[30px] w-[100px]'}
                background={'bg-white'}
                onClick={() => {
                  if (userLogin?.statusVerify !== 1) {
                    setIsShowNotification(true);
                    return;
                  }
                  navigator?.clipboard?.writeText(clipboardLink);
                  toast.success('Sao chép link thành công!');
                }}
              >
                <span className={'text-sm font-semibold text-[#F15836]'}>Lấy link</span>
              </ButtonGradient>
              <ButtonCustom
                label={'Xem chi tiết'}
                onClick={() => {
                  window.open(detailLink, '_blank');
                }}
                background={'bg-[#F15836]'}
                className={'h-[30px] w-[100px] !rounded-l-[10px] !text-sm !font-semibold'}
              />
            </div>
          </th>
        </tr>
      );
    },
    [currentPage, perPage, userLogin?.statusVerify]
  );

  const onNextPageMobile = () => {
    setCurrentPage(currentPage + 1);
    mutationSearchCategory.mutate({
      name: '',
      page: currentPage + 1,
      sizeOfPage: PER_PAGE_DEFAULT,
    });
  };

  return (
    <>
      <CategoryContext.Provider
        value={{
          packTypeChoice,
          numExpiredChoice,
          traSau,
          traTruoc,
          amount,
          setPackTypeChoice,
          setTraTruoc,
          setAmount,
          setTraSau,
          setNumExpiredChoice,
        }}
      >
        <Products name={PATH_PAGE.PRODUCTS_CATEGORY}>
          <div className={'mb-6 mt-4 flex flex-row space-x-2'}>
            <div className={'relative h-full w-full'}>
              <TextForm
                placeholder={'Tìm kiếm danh mục'}
                className={'h-[40px] rounded-[10px] pl-6'}
                onChange={(e) => setSearchString(e.target.value)}
              />
            </div>
            <ButtonCustom
              label={
                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M13.4688 12.7812L17.5938 16.9062"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8.3125 14.1562C11.9196 14.1562 14.8438 11.2321 14.8438 7.625C14.8438 4.01789 11.9196 1.09375 8.3125 1.09375C4.70539 1.09375 1.78125 4.01789 1.78125 7.625C1.78125 11.2321 4.70539 14.1562 8.3125 14.1562Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              }
              className={'hidden h-[40px] w-[40px] px-2.5 md:block'}
              onClick={() => onSearchCategory()}
            />
            <button
              className={
                'h-[40px] min-w-[99px] rounded-t-[8px] rounded-bl-[8px] bg-[#F15836] text-base font-bold text-white' +
                ' md:hidden'
              }
              onClick={() => onSearchCategory()}
            >
              Tìm kiếm
            </button>
          </div>
          <div className={'hidden w-full md:contents'}>
            <TableV2 labelHeaders={labelHeader} dataRows={dataTable.items} renderRow={renderRow} />
          </div>
          {window.innerWidth <= 768 && (
            <div className={'flex h-fit w-full flex-col space-y-2.5 md:hidden'}>
              <InfiniteScroll
                dataLength={dataTable.items.length + 15}
                next={() => onNextPageMobile()}
                hasMore={true}
                loader={<></>}
                endMessage={<></>}
                refreshFunction={() => console.log('refresh')}
                pullDownToRefresh
                pullDownToRefreshThreshold={50}
                pullDownToRefreshContent={<></>}
                releaseToRefreshContent={<></>}
                className={'space-y-2.5'}
              >
                {dataTable.items.map((item, index) => (
                  <div
                    key={index}
                    className={
                      'flex min-h-[116px] w-full flex-col justify-between rounded-t-[16px] rounded-bl-[16px] bg-white' +
                      ' px-4 py-2 shadow-base'
                    }
                  >
                    <div className={'flex h-full w-full flex-row justify-between'}>
                      <div className={'flex flex-row items-center justify-between space-x-0.5'}>
                        {getIconCategory(getCategoryName(item.name))}
                        <span className={'text-sm font-bold text-[#404040]'}>{item.name}</span>
                      </div>
                      <div className={'flex flex-row items-center space-x-2 text-sm font-bold text-[#F15836]'}>
                        <svg
                          className={'mr-1'}
                          width="19"
                          height="19"
                          viewBox="0 0 19 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.87891 2.89258C7.20831 2.89495 6.56585 3.1624 6.09166 3.63658C5.61747 4.11077 5.35003 4.75323 5.34766 5.42383C5.34766 5.87383 5.47534 6.29177 5.68178 6.65458C4.66872 7.24745 3.87559 8.08895 3.44922 9.08008H3.37891C3.34174 9.08092 3.30479 9.07423 3.27028 9.06039C3.23578 9.04656 3.20444 9.02587 3.17815 8.99959C3.15186 8.9733 3.13118 8.94196 3.11734 8.90745C3.10351 8.87295 3.09681 8.83599 3.09766 8.79883C3.09766 8.69983 3.14828 8.62108 3.22084 8.57045L2.57003 7.65639C2.38573 7.78455 2.23515 7.95537 2.13114 8.1543C2.02712 8.35322 1.97275 8.57435 1.97266 8.79883C1.97266 9.4907 2.48903 10.0577 3.15053 10.1702C3.12184 10.3671 3.09766 10.5634 3.09766 10.7676C3.09766 12.1693 3.84241 13.3843 4.92578 14.2832C4.78966 14.8457 4.85772 15.4453 5.29478 15.883C5.61746 16.2029 6.05344 16.3823 6.50781 16.3823C6.96219 16.3823 7.39817 16.2029 7.72084 15.883L7.93178 15.672C8.37109 15.753 8.81266 15.8301 9.28516 15.8301C9.75766 15.8301 10.1992 15.753 10.6385 15.672L10.8495 15.883C11.1721 16.2029 11.6081 16.3823 12.0625 16.3823C12.5169 16.3823 12.9529 16.2029 13.2755 15.883C13.7036 15.4543 13.7677 14.8721 13.6445 14.3181C14.0956 13.9517 14.4818 13.5121 14.787 13.0176H16.0352V8.51758H14.7521C14.5479 8.18604 14.3059 7.87931 14.031 7.60352L14.3477 5.86314V5.14258H13.7852C13.7852 5.14258 12.434 5.16508 11.2888 6.02177C10.9881 5.93502 10.683 5.86442 10.3747 5.81027C10.3972 5.68539 10.4102 5.55545 10.4102 5.42383C10.4102 4.03277 9.26997 2.89258 7.87891 2.89258ZM7.87891 4.01758C8.66078 4.01758 9.28516 4.64195 9.28516 5.42383C9.28516 5.52058 9.26772 5.61283 9.24972 5.70508C8.34241 5.70958 7.48572 5.88508 6.70159 6.17983C6.55224 5.956 6.47257 5.69292 6.47266 5.42383C6.47266 4.64195 7.09703 4.01758 7.87891 4.01758ZM13.082 6.37333C13.091 6.37108 13.091 6.37502 13.0995 6.37333L12.8885 7.65583L12.8362 7.95508L13.082 8.16602C13.4576 8.49129 13.7678 8.88512 13.9961 9.32645L14.1542 9.64258H14.9102V11.8926H14.1542L13.9961 12.2093C13.7216 12.7515 13.2885 13.2285 12.7305 13.6324L12.326 13.9316L12.5724 14.389C12.7063 14.6151 12.6821 14.8941 12.4841 15.0921C12.4307 15.1477 12.3666 15.192 12.2956 15.2223C12.2247 15.2526 12.1484 15.2682 12.0712 15.2682C11.9941 15.2682 11.9177 15.2526 11.8468 15.2223C11.7758 15.192 11.7117 15.1477 11.6583 15.0921L11.2539 14.6871L11.0255 14.4767L10.7263 14.547C10.2695 14.6522 9.78409 14.7051 9.28516 14.7051C8.80018 14.7068 8.31655 14.6538 7.84347 14.547L7.54534 14.4767L7.31641 14.6876L6.91197 15.0915C6.85857 15.1473 6.79443 15.1916 6.72343 15.222C6.65242 15.2523 6.57602 15.2679 6.49881 15.2679C6.42161 15.2679 6.3452 15.2523 6.2742 15.222C6.20319 15.1916 6.13906 15.1473 6.08566 15.0915C5.99308 15.0019 5.93391 14.8833 5.91795 14.7554C5.90199 14.6275 5.9302 14.498 5.99791 14.3884L6.24428 13.9316L5.83984 13.633C4.82228 12.8938 4.22266 11.8858 4.22266 10.7676C4.22266 8.6627 6.42203 6.83008 9.28516 6.83008C9.97703 6.83008 10.6363 6.93358 11.2365 7.12877L11.5352 7.23452L11.7815 7.02358C12.1832 6.66527 12.6798 6.47233 13.082 6.37333ZM12.6602 9.64258C12.3508 9.64258 12.0977 9.8957 12.0977 10.2051C12.0977 10.5145 12.3508 10.7676 12.6602 10.7676C12.9695 10.7676 13.2227 10.5145 13.2227 10.2051C13.2227 9.8957 12.9695 9.64258 12.6602 9.64258Z"
                            fill="#F15836"
                          />
                        </svg>
                        {`${item.commission}`}
                      </div>
                    </div>
                    <div className={'grid grid-cols-2 gap-2 border-t border-[#EFEFEF] pt-2'}>
                      <ButtonGradient
                        className={'h-[32px] w-full !rounded-t-[8px] !rounded-bl-[8px]'}
                        background={'bg-white !rounded-t-[6px] !rounded-bl-[6px]'}
                        onClick={() => {
                          if (userLogin?.statusVerify !== 1) {
                            setIsShowNotification(true);
                            return;
                          }
                          navigator?.clipboard?.writeText(item.link);
                          toast.success('Sao chép link thành công!');
                        }}
                      >
                        <span className={'text-xs font-bold leading-[18px] text-[#F15836]'}>Lấy link</span>
                      </ButtonGradient>
                      <button
                        className={
                          'h-[32px] w-full rounded-t-[8px] rounded-bl-[8px] bg-[#F15836] text-[12px] font-bold text-white md:hidden'
                        }
                        onClick={() => {
                          navigate(item.link);
                        }}
                      >
                        Xem chi tiết
                      </button>
                    </div>
                  </div>
                ))}
              </InfiniteScroll>
            </div>
          )}
          {/* <div className={'mt-6 hidden md:contents'}>
            <div className="pt-2">
              <PaginationCustom
                currentPage={currentPage || 1}
                setCurrentPage={(_page: number) => {
                  setCurrentPage(_page);
                  onSearchCategory({ currentPage: _page });
                }}
                perPage={perPage}
                setPerPage={(_perPage: number) => {
                  setPerPage(_perPage);
                  setCurrentPage(1);
                  onSearchCategory({ perPage: _perPage });
                }}
              />
            </div>
          </div> */}
        </Products>
      </CategoryContext.Provider>
      {isShowNotification && <AccountAuthen setIsShowNotification={setIsShowNotification} />}
    </>
  );
};

const getCategoryName = (key: string) => {
  if (key === 'Sim số') {
    return 'SIMSO';
  } else if (key === 'Gói cước') {
    return 'GOICUOC';
  }
  return 'Vietlott';
};

const labelHeader = [
  {
    label: 'STT',
    className: 'text-[#818181] font-semibold text-[10px] leading-[12px] uppercase w-[65px]',
  },
  {
    label: 'Danh mục',
    className: 'text-[#818181] font-semibold text-[10px] leading-[12px] uppercase',
  },
  {
    label: 'Tỷ lệ hoa hồng',
    className: 'text-[#818181] font-semibold text-[10px] leading-[12px] uppercase',
  },
  {
    label: 'Thao tác',
    className: 'text-[#818181] font-semibold text-[10px] leading-[12px] uppercase w-[272px]',
  },
];
